import styled from "@emotion/styled";
import React from "react";

interface IProps {
  value: boolean;
  title?: string;
  onChange: () => void;
}

const colors = {
  primary800: "#363870",
  primary650: "#8082C5",
  primary300: "#C6C9F4",
  primary100: "#F1F2FE",
  primary50: "#f8f8ff",
  white: "#FFFFFF",
  blue500: "#7075E9",
  success: "#35A15A",
  error: "#ED827E",
  success550: "#1F8943",
  success500: "#35A15A",
  success100: "#E6F3EB",
  error550: "#D66662",
  error500: "#ED827E",
  error100: "#FCF0EF",
  attention550: "#D9916E",
  attention500: "#EDAA8A",
  attention100: "#FCF4F1",
};

const Root = styled.div`
  display: flex;
  flex-direction: column;

  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 24px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.primary100};

    :disabled {
      background-color: ${colors.primary300};
    }

    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    //
    width: 18px;
    height: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    box-shadow: 0px 2px 4px rgba(54, 56, 112, 0.12);
  }

  input:checked + .slider {
    background-color: ${colors.blue500};
  }

  input:focus + .slider {
    box-shadow: 0 0 1px ${colors.primary100};
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }

  .slider.round {
    border-radius: 8px;
  }

  .slider.round:before {
    border-radius: 6px;
  }
`;

const Switch: React.FC<IProps> = ({ value, onChange, title }) => {
  return (
    <Root>
      <label className="switch" title={title}>
        <input type="checkbox" checked={value} onChange={onChange} />
        <span className="slider round" />
      </label>
    </Root>
  );
};
export default Switch;
